import React from "react";
import PropTypes from "prop-types";
import { Redirect } from "@reach/router";

function PrivateRoute({ path, children, isLoggedIn }) {
  if (!isLoggedIn) {
    return <Redirect from={path} to="/sign-in" />;
  }

  return children;
}

PrivateRoute.propTypes = {
  path: PropTypes.string,
  children: PropTypes.any,
  isLoggedIn: PropTypes.bool,
};

PrivateRoute.defaultProps = {
  isLoggedIn: true,
};

export default PrivateRoute;
